<template>
  <el-row type="flex">
    <el-col :span="20">
      {{tableItemCount}}
    </el-col>
    <el-col :span="4"></el-col>
  </el-row>
</template>

<script>
export default {
  name: 'WFlowMapTableItemCount',
  props: {
    perfRecords: {
      type: Object,
    },
    perfKey: {
      type: String,
    },
  },
  computed: { // NOTE: Ju (DBMS_CODE_REVIEW) computed로 작성하여 perfRecords나 perfKey가 변경될 때 자동으로 tableItemCount 변경이 발생하도록 함.
    tableItemCount() {
      const perfTable = this.perfRecords;
      const key = this.perfKey;
      if (!perfTable[key]) {
        return 0;
      }
      return perfTable[key].length;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapTableItemCount.vue